export default "__VITE_ASSET__3dff5749__"